import { render, staticRenderFns } from "./create-quote.vue?vue&type=template&id=33972a54&"
import script from "./create-quote.vue?vue&type=script&lang=ts&"
export * from "./create-quote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports